const informParent = ({ type, message }) => {
  const allowedOrigins = process.env.REACT_APP_ALLOWED_ORIGINS.split(',');
  allowedOrigins.forEach((origin) => {
    window.parent.postMessage({ type, message }, origin);
  });
};

export default informParent;
